/**
 * Page unifiée « Équipe & Magasins » — URL canonique `/admin/equipe-magasins`
 *
 *   ?tab=users (défaut super-admin) → AdminUsersPage
 *   ?tab=magasins                  → AdminMagasinsPage
 *   ?tab=b2b (défaut admin magasin) → AdminB2BCompaniesTab
 *
 * `/utilisateurs`, `/admin/users`, `/admin/magasins` redirigent ici (App.js).
 */
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import AdminUsersPage from './AdminUsersPage';
import AdminMagasinsPage from './AdminMagasinsPage';
import AdminB2BCompaniesTab from './AdminB2BCompaniesTab';
import { usePermissions } from '../contexts/PermissionsContext';

export default function AdminEquipeMagasinsRouter() {
  const [searchParams] = useSearchParams();
  const { isSuper } = usePermissions();
  const defaultTab = isSuper ? 'users' : 'b2b';
  const tab = (searchParams.get('tab') || defaultTab).toLowerCase();

  if (!isSuper && (tab === 'users' || tab === 'magasins')) {
    return <Navigate to="/admin/equipe-magasins?tab=b2b" replace />;
  }

  if (tab === 'magasins') return <AdminMagasinsPage />;
  if (tab === 'b2b') return <AdminB2BCompaniesTab />;
  return <AdminUsersPage />;
}
